import React from 'react'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'
import { Container } from 'components/Layout'
import cn from 'classnames'
import { PhoneSystemExtensionEditForm } from '../PhoneSystemExtensionEditForm'
import QrCode from 'qrcode.react'
import { IPhoneSystemExtensionEditFormModal } from './PhoneSystemExtensionEditFormModal.action'
import * as sLay from 'styles/modules/layout.scss'

export interface IPhoneSystemExtensionEditFormModalProps
  extends IPhoneSystemExtensionEditFormModal {
  modalCancel: () => undefined
  modalConfirm: () => undefined
}

export const PhoneSystemExtensionEditFormModal = (
  props: IPhoneSystemExtensionEditFormModalProps
) => {
  const {
    modalConfirm,
    phoneSystemId,
    extensionId,
    name,
    number,
    username,
    password,
    displayNumber,
    didNumbers,
  } = props

  return (
    <Container paddingTop paddingBottom className="sm">
      <div style={{ margin: '0 30px' }}>
        {!!extensionId ? (
          <>
            <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>Extension Details</div>

            <div className={cn(sText.descrip3, sText.center, sMarg.mb30)}>
              You can login to this extension using the "Acrobits" "Cloud Softphone" app. Download
              the app and scan the QR code below.
            </div>

            <div className={cn(sLay['layout-row'], sLay['layout-align-start-center'], sMarg.mb30)}>
              <QrCode
                value={`csc:${encodeURIComponent(username)}:${encodeURIComponent(
                  password
                )}@cloudsip`}
              />
              <div style={{ marginLeft: '20px' }}>
                <div className={cn(sText.descrip3)}>Username: {username}@cloudsip</div>
                <div className={cn(sText.descrip3)}>Password: {password}</div>
              </div>
            </div>
          </>
        ) : null}
        <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>
          {!!extensionId ? 'Edit' : 'Add'} Extension
        </div>

        <PhoneSystemExtensionEditForm
          onAfterSubmit={modalConfirm}
          initialValues={{
            phoneSystemId,
            extensionId,
            name,
            number,
            displayNumber,
          }}
          didNumbers={didNumbers}
        />
      </div>
    </Container>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemExtensionEditFormModal/PhoneSystemExtensionEditFormModal.tsx